import React from 'react';
import SshService from '../../../services/ssh-service';

const sshRender = (params) => {
    const {value, data} = params;
    const openConnection = () => {

        SshService.openSshConnection(data.project_id, data.id_ssh);
    }

    return (
        <>
            <div onClick={openConnection}>
                {value}
            </div>
        </>
    );
};

export default sshRender;